import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const Typegroup_service = {
    addTypeGroup,
    queryAlltable,
    updateTypegroup,
    removeTypegroup,
    getGroupList,
    getProviderGroupById
};

function addTypeGroup(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "typegroup/addTypeGroup/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function queryAlltable(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "typegroup/findGroupCompany/" + data.providerType + "/" + data.page + "/" + data.pageSize + "?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getGroupList(params){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "typegroup/getGroupList/" + params.provider_type + "?authorization=" + json_cookie.token, {params : params})
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function updateTypegroup(formData) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "typegroup/updateTypeGroup/?authorization=" + json_cookie.token, formData)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function removeTypegroup(row_id) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "typegroup/removeTypeGroup/?authorization=" + json_cookie.token, {row_id:row_id})
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getProviderGroupById(id){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject)=>{
        axios.get(config.API_URL + 'typegroup/getProviderGroupById/?authorization='+json_cookie.token, {params : {'id' : id}})
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}